import React from 'react';
import { BaasicTimeInputTemplate } from 'themes/components';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

class BaasicTimeInput extends React.Component {
	render() {
		return <BaasicTimeInputTemplate {...this.props} />;
	}
}

BaasicTimeInput.propTypes = {
	onValueChange: PropTypes.func,
	format: PropTypes.string,
	mask: PropTypes.array,
	placeholderFormat: PropTypes.string,
	className: PropTypes.string,
	field: PropTypes.object,
	className: PropTypes.string,
};

export default observer(BaasicTimeInput);
